import { Component, Inject, OnInit } from '@angular/core';
import { GolfPlayer } from 'src/app/_interfaces';
import { AnalyticsService, AppStringsService, FollowedPlayerService, RouteParserService } from 'src/app/_services';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImageComponent } from '../../_modules/image/image.component';
import { MatButtonModule } from '@angular/material/button';
import { PlayerDetailComponent } from './player-detail/player-detail.component';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-player-dialog',
    templateUrl: './player-dialog.component.html',
    styleUrls: ['./player-dialog.component.scss'],
    imports: [MatButtonModule, ImageComponent, PlayerDetailComponent, MatIcon]
})
export class PlayerDialogComponent implements OnInit {
    public my_players: GolfPlayer[] = [];
    public following: boolean = false;




    constructor(
        public dialogRef: MatDialogRef<PlayerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public player: GolfPlayer,
        private analyticsService: AnalyticsService,
        private routeParser: RouteParserService,
        public appStringAPI: AppStringsService,
        private dialog: MatDialog,
        private followAPI: FollowedPlayerService,
        private ssr: SsrlocalstoreService
    ) { }

    ngOnInit(): void {
        // only run follow/localStorage-dependent logic in browser
        if (this.ssr.isClientSide) {
            this.handleMyFollowed();

            this.followAPI.followed_players.subscribe((data) => {
                this.following = (data ?? []).includes(this.player.id);
            });
        } else {
            // SSR safe defaults (client will hydrate and then update)
            this.following = false;
            this.my_players = [];
        }
    }

    openPlayerGear(merchandise_url: string) {
        if (!merchandise_url) return;

        const payload = {
            name: 'player.merchandise.link.view',
            screen_name: `Player details`,
            parameters: {
                golf_player_id: this.player.id,
                url: merchandise_url
            }
        };

        this.analyticsService.postEvent('button_press', payload);

        if (this.ssr.isClientSide) {
            window.open(merchandise_url);
        }
    }

    downloadAppDialog() {
        const url = 'bleachr://web_follow_player';
        this.routeParser.parseBleachrRoutes(url);
    }

    handleMyFollowed() {
        this.followAPI.getFollowedPlayers().then((data) => {
            this.my_players = data;
        }).catch((e) => {
            console.error(e);
        })
    }

    handleFollow(click: Event) {
        click.stopPropagation();
        const loggedIn = this.ssr.isLoggedIn()
        if (!loggedIn) {
            this.dialog.open(InfoDialogComponent, {
                data: {
                    notice_type: 'login'
                },
                height: '136px',
                width: '336px'
            })
            return;
        }
        this.updateFollowList(this.player.id);
    }

    async updateFollowList(id) {
        const idx = this.my_players.findIndex(player => {
            return player.id === id;
        })
        if (idx !== -1) {
            this.my_players.splice(idx, 1);
            this.followAPI.unfollowPlayer(id);
        } else {
            this.my_players.unshift(this.player);
            this.followAPI.followPlayer(id);
        }
    }

    close() {
        this.dialogRef.close()
    }
}
